import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { Autocomplete, Button, DialogActions, InputLabel, TextField } from "@mui/material";



export default function EditVehicles({ open, closeVehicles,vehicleDropdown ,editData,handleChangeEditVehicleValue,handleClickEditVehicleSubmit }) {
    // console.log("editData",editData?.ac_names);
    
  return (
    <>
      <Dialog
        open={open}
        onClose={closeVehicles}
        aria-labelledby="responsive-dialog-title"
      >
            <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit Vehicle "}
        </DialogTitle>
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            // marginTop: "1.2rem",
          }}
        >
          {"Edit Variant name"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                // height: "30px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={editData?.variant}
              onChange={(e) =>
                handleChangeEditVehicleValue("variantName", e.target.value)
              }
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^a-zA-Z ]*/g, "");
              }}
            ></input>
          </DialogContentText>
        </DialogContent>

        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            // marginTop: "1.2rem",
          }}
        >
          {"Edit Battery Capacity name"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                // height: "30px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={editData?.battery_capacity}
              onChange={(e) =>
                handleChangeEditVehicleValue("batteryCapacity", e.target.value)
              }
            //   onInput={(e) => {
            //     e.target.value = e.target.value
            //       .trimStart()
            //       .replace(/[^0-9]*/g, "");

            //   }}
            ></input>
          </DialogContentText>
        </DialogContent>
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            // marginTop: "1.2rem",
          }}
        >
          {"Select AC Connector"}
        </DialogTitle>
        <DialogContent>
                  <Autocomplete
                    // className={classes.formcontrolstyle}
                    multiple
                    id="tags-outlined"
                    options={(vehicleDropdown?.acTypes || []).sort((a, b) => a.name.localeCompare(b.name))}
                    getOptionLabel={(option) => option.name}
                    filterSelectedOptions
                    defaultValue={(vehicleDropdown?.acTypes || []).filter((option) =>
                        (editData?.ac_names || []).includes(option.name)
                      )}
                      onChange={(event, newValue) => handleChangeEditVehicleValue("acName", newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="AC Connector"
                        placeholder="Select Ac"
                        size="small"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                  />
        </DialogContent>

        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            // marginTop: "1.2rem",
          }}
        >
          {"Select DC Connector"}
        </DialogTitle>
        <DialogContent>
        <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={(vehicleDropdown?.dcTypes || []).sort((a, b) => a.name.localeCompare(b.name))}
                      getOptionLabel={(option) => option.name}
                      filterSelectedOptions
                      defaultValue={(vehicleDropdown?.dcTypes || []).filter((option) =>
                        (editData?.dc_names || []).includes(option.name)
                      )}
                      onChange={(event, newValue) => handleChangeEditVehicleValue("dcName", newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="DC Connector"
                          placeholder="Select Dc"
                          size="small"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          {option.name}
                        </li>
                      )}
                    />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100.17px",
              height: "40px",
              marginBottom: "1.2rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            // disabled={!value && !editfile}
            onClick={() => handleClickEditVehicleSubmit()}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
